export function isHasBacktestsCheck(check: { id?: string | null }): boolean {
    return (check.id ?? '').toLowerCase() === 'has_backtests';
}
